import { Component, OnInit, AfterViewInit, Inject, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import { APP_CONFIG, AppConfig } from '../config/app.config.module';
import { DialogsService } from '../dialogs/dialogs.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Router, ActivatedRoute, ParamMap, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PortalService } from '../services/portal.service';
import { environment } from '../../environments/environment';
import {
  MatPaginator, MatSort
} from '@angular/material';
//import { tileLayer, latLng, circle, polygon, marker, icon, Layer, polyline } from 'leaflet';
import * as L from 'leaflet';
import { ISubscription } from 'rxjs/Subscription';
// import { TopnavService } from '../header/topnav/topnav.service';
import { TopnavService } from '../header/topnav/topnav.service';
import { NavService } from '../header/nav/nav.service';
import { SharedService } from '../common/shared.service';
import { style } from '@angular/core/src/animation/dsl';

/**
 * Author: Redza Rosly
 * 
 * Date Created: July 19th 2018
 * 
 * Description: Component class for PDRM Traffic Info - /trafficinfo
 **/
@Component({
  selector: 'gosg-trafficinfo',
  templateUrl: './trafficinfo.component.html',
  styleUrls: ['./trafficinfo.component.css']
})
export class TrafficinfoComponent implements OnInit, AfterViewInit, OnDestroy {

  apiUrl = environment.infoTrafficURL;
  // apiUrl = 'http://10.1.70.47:8000/'; // local

  private subscriptionLang: ISubscription;
  public subscriptionFontType: ISubscription;
  private subscriptionFontSize: ISubscription;
  private sharedDS: string = this.config.urlDservicePublic;

  public fontSize: any = {
      "sizeS" : "14px",
      "sizeM" : "19px",
      "sizeL" : "23px",
      "no_styles" : "0.9em"
  };

  public fontType: string = 'Arial';
  private mStyle: string; 
  private currentName;
  private currentLatLng;
  private currColor;

  dataAlpha = [];
  keyword: string;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('input') input: ElementRef;

  pageSize = 10;
  pageCount = 1;
  totalRec = 0;
  loading = false;
  noPrevData = true;
  noNextData = false;
  allStreetNames: any;
  streetName: any;
  cities: any = []
  asn: any = []
  tfsn: any = []
  streetNames: any = [];
  trafficData: any = [];
  diffStreetNames = [];
  sameStreetNames = [];
  streetFlows = null;
  gotPrediction: boolean;
  streetPrediction: any = [];
  predictionData: any = [];
  selStreetName: any;
  current: any;
  after1hr: any;
  after2hr: any;
  after3hr: any;
  lang:any;
  langId = localStorage.getItem('langID');
  languageId: any;
  recordTable = null;
  id;
  custom: any;
  rp;
  isActiveList: boolean = false;

  isActive: any;
  currlang: any;
  currlangMOB: any;
  titleServices: any;

  showNoData = false
  step = 0;

  mymap;
  marker;
  popup = L.popup();
  defaultIcon = L.icon({
    iconUrl: 'assets/marker-icon.png',
    shadowUrl: 'assets/marker-shadow.png',
    iconSize: [25, 41], // size of the icon
    shadowSize: [40, 41], // size of the shadow
    iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
    shadowAnchor: [0, 0],  // the same for the shadow
    popupAnchor: [12, 0] // point from which the popup should open relative to the iconAnchor
  });
  feature: any;
  layerGroup: L.LayerGroup<any>;
  dsvcCode: number;
  agcCode: number;
  
  // public eRatingUrl = "https://goserating.mampu.gov.my/erating-public?services_key=37b6375e-5b4a-11e9-b906-005056a30c08";
  // public manualUrl: string = '/media/documents/Tatacara%20-%20Informasi%20trafik%20lembah%20klang_english.pdf';
  public eRatingUrl: string = ''; 
  public manualUrl: string =  '';
  // route = L.polyline([[ 101.741834,3.081827],[ 101.741807,3.082012],[ 101.741794,3.08221],[ 101.741738,3.083809],[ 101.741723,3.084906],[ 101.741723,3.084907],[ 101.741711,3.085749],[ 101.741651,3.086318],[ 101.741521,3.086954],[ 101.741301,3.088004],[ 101.740145,3.091723],[ 101.739996,3.092204],[ 101.739529,3.093657],[ 101.738819,3.096002]], {color: 'red'}).addTo(this.mymap);
  public myflag: any;
  selCity: any;
  selRoad: string;
  searchFilter: any;
  mHeight: string;

  public cityName: any;
  
  constructor(
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    private portalservice: PortalService,
    private translate: TranslateService,
    private topnavservice: TopnavService,
    private navService: NavService,
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    @Inject(APP_CONFIG) private config: AppConfig
  ) {
    //this.navService.restricted = false;
    this.navService.digitalTop = true;
    this.loading = true;
    this.subscriptionLang = translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // this.sharedService.errorHandling(event, (function(){
        const myLang = translate.currentLang;

        if (myLang == 'en') {

            translate.get('HOME').subscribe((res: any) => {
                this.lang = 'en';
                this.languageId = 1;
                //this.getFaq(this.langID);
            });
        }

        if (myLang == 'ms') {

            translate.get('HOME').subscribe((res: any) => {
                this.lang = 'ms';
                this.languageId = 2;
                //this.getFaq(this.langID);
            });
        }

        if (this.popup.isPopupOpen)
          this.popup.closePopup()
  

      if (this.topnavservice.flagLang) {
        this.gotPrediction = false;
        console.log('masuk tukar bahasa');
        this.mymap.closePopup();
        this.getDSName();
        this.getCitiesData();
        this.keyword = '';
        this.pageCount = 1;
        this.mymap.flyTo([4.8142568, 108.5806004], 6);
        this.popup.remove();
      }

      

      setTimeout(()=>{
        this.translate.get('pageTitle.home').subscribe((title:string) => {
          title = this.translate.instant('trafficinfo.title2');
          this.sharedService.setTitle(title);
        }); 
      },500);

    });

    this.activatedRoute.queryParams.subscribe(params => {
      let lng = params['language'];
      if (lng && lng.toLowerCase() == 'my') {
        this.myflag = {language:"my"};
        this.translate.setDefaultLang('ms');
        this.translate.use('ms');
      } else {
        this.myflag = null;
      } 
    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data)=>{
      this.fontSize = data;
      $('.mat-input-placeholder').css('font-size', this.fontSize.sizeS);
      this.mStyle = 'style="cursor:pointer; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
      this.mymap.closePopup();
      if(this.selCity)
        this.getStreetNamesData(this.selCity);
      if (this.allStreetNames) {
        console.log('masuk font size');
      }
    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data)=>{
      this.fontType = data;
      this.mStyle = 'style="cursor:pointer; font-family:' + this.fontType + '; font-size:' + this.fontSize.sizeS + ';"';
      this.mymap.closePopup();
      if(this.selCity)
        this.getStreetNamesData(this.selCity);
      if (this.allStreetNames) {
        console.log('masuk font type');
      }
    
    });
  }

  ngOnInit() {

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else { 
        this.languageId = 1;
      }
    }

    this.mHeight = '300px';

    // this.dsvcCode = this.router.url.split('/')[]
    // AGENCY & DSERVICE CODE FOR VALIDATION
    let sub = this.route.queryParams.subscribe((params: Params) => {
      this.dsvcCode = parseInt(params.service);
      this.agcCode = parseInt(params.agency);
    });
    
    this.gotoUrl(this.dsvcCode);
    this.getDSName();
    // this.triggerDserviceValidation(this.dsvcCode);

    this.gotPrediction = false;
    this.getDefaultMap();

    this.id = setInterval(() => {
      if(this.selCity)
        this.getStreetNamesData(this.selCity);
    }, 300000);
    
  }

  ngAfterViewInit() {
 
    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title:string) => {
      title = this.translate.instant('trafficinfo.title2');
      this.sharedService.setTitleAndGtag(title);
    });
    
    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();

    this.keyword = '';
    this.pageCount = 1;
    this.mymap.flyTo([4.8142568, 108.5806004], 6);
    this.popup.remove(); 
  }

  ngOnDestroy() {
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();

    if (this.id) {
      clearInterval(this.id);
    }

    if(this.feature) {
      this.feature.clearLayers();
      this.layerGroup.clearLayers();
    }
  }

  getDSName(){
    this.loading = true;
    this.sharedService.readPortalById('digitalservice/details/title/',this.dsvcCode,this.languageId).subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){
        
        this.titleServices = data['object'].digitalServiceDetailsTitle;
        console.log(this.titleServices);

        this.loading = false;
      }).bind(this));
    },
    error => {
      this.loading = false;
    });
  }

  gotoUrl(code){
    this.loading = true;
    let a = localStorage.getItem("idDservice");
    this.sharedService.readPortalById('digitalservice/details/',code).subscribe(
    data => {

      this.sharedService.errorHandling(data, (function(){
        let getObj = data['object'];     
        if(getObj.surveyUrl){
          this.eRatingUrl = getObj.surveyUrl; 
        } 
        if(getObj.manual){
          this.manualUrl = '/media/documents/'+getObj.manual;
        }
        this.loading = false;
      }).bind(this));
    },
    error => {
      this.loading = false;
    });
  }

  openWindow(url) {
    window.open(url, '_blank', 'location=yes, height=570,width=520, scrollbars=yes,status=yes');
  }

  getDefaultMap() {
    this.mymap = L.map('dirmap');
    this.mymap.setView([4.8142568, 108.5806004], 6);

    L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
      attribution: '',
      maxZoom: 16,
      id: 'osm.streets', 
      accessToken: 'pk.eyJ1IjoicmVkemEiLCJhIjoiY2pmcGZxNzRrMjYzbzMwcG83bGRxY2FtZyJ9.uMHQpYc0Pvjl4us27nHH8w'
    }).addTo(this.mymap);
    // $('.leaflet-control-attribution').hide();

    this.layerGroup = L.layerGroup().addTo(this.mymap);

    let attribution = this.mymap.attributionControl;
    attribution.setPrefix(false);
  }

  checkStreetName(e) {
    let keyword = e;
    if(keyword.length == 0 || keyword.length > 3) {
      this.isActiveList = true;
    } else
      this.isActiveList = false;
  }

  getCity(e){
    // console.log({'city':e});

    this.selCity = e;

    this.isActiveList = false;
    this.streetName = '';
    this.predictionData = [];
    this.gotPrediction = false;
    // this.showNoData = true;

    this.mHeight = '300px';

    this.getStreetNamesData(encodeURIComponent(this.selCity));
  }

  getStreetData(e){

    // this.selRoad = encodeURIComponent(e);

    let streetData = e;
    // console.log({'getStreetData':streetData});

    this.getTrafficPredictionData(streetData.properties.name, [streetData.geometry.coordinates[0][1],streetData.geometry.coordinates[0][0]], streetData.properties.color, this.languageId);

  }

  getCitiesData() {
    this.loading = true;

    this.sharedService.readDirect(this.apiUrl+'service-trafficinfo/getTrafficInfoCitiesList').subscribe(
      data => {
        // this.asn = [];
        this.portalservice.errorHandling(data, (function () {

          this.cities = data['data'];

          // console.log({'cities':this.cities});
          
          // this.populateStreetNames();

          /*this.allStreetNames.forEach(elASN => {
            this.asn.push({ "name": elASN.Street, 'latlng': null, 'poly': null, 'level': null, 'color': null, "additional": false })
          });*/
          // console.log('%c asn ', 'color: green; font-weight: bold');
          // console.log({ "Traffic Length": this.asn.length, "data": this.asn, "Date": datenow })

        this.loading = false;

        }).bind(this));
      },
      error => {
        this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
        this.loading = false;
      });
  }

  getStreetNamesData(city) {
    
    this.loading = true;

    this.sharedService.readDirect(this.apiUrl+'service-trafficinfo/getTrafficInfoStreetsList/city/'+city).subscribe(
      data => {
        this.streetNames = [];
        
        this.portalservice.errorHandling(data, (function () {
          
          this.trafficData = data['data']['featureCollection'];

          this.mymap.closePopup();

          if(this.feature) {
            this.feature.clearLayers();
            this.layerGroup.clearLayers();
          }

          if(this.trafficData.length != 0) {
            this.feature = L.geoJSON(this.trafficData).addTo(this.mymap);
            this.mymap.fitBounds(this.feature.getBounds());
          } else {
            this.mymap.setView([4.8142568, 108.5806004], 6);
          }

          let tempArr = [];
          let finalArr = [];
      
          this.trafficData.forEach((el,i) => {
                  
                  tempArr.push(el);
            
                  const match = tempArr.filter(e => e.properties.name === el.properties.name); // for comparison
                  const match1 = finalArr.filter(e => e.properties.name === tempArr[i].properties.name);
      
                  match['name'] = match[0].properties.name;
                  
                  if(match.length >= 1 && match1.length == 0) {
                      finalArr.push(match[0]);
                      this.streetNames.push(match[0]);
                  } 
          });
          // finalArr.concat(tempArr);
          // this.streetNames = finalArr;
      
          // console.log({'streetNames':this.streetNames});

          // this.streetNames.forEach(el => {
          //   console.log({'road name': el.properties.name});
          // });
          
          this.populateStreetNames();

        }).bind(this));
      },
      error => {
        this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
        this.loading = false;
      });
  }

  populateStreetNames() {
    
    // this.asn = [];
    console.log('populating..');

    this.trafficData.forEach(el => {

      let arrLatLng = [el.geometry.coordinates[0][1],el.geometry.coordinates[0][0]];
      let getLatLng = new L.LatLng(el.geometry.coordinates[0][1],el.geometry.coordinates[0][0]);
      // console.log(arrLatLng);
      
        let mStyle = this.mStyle;
        
        let popEl = '<div '+mStyle+' id="' + arrLatLng + '" d-color="' + el.properties.color + '" d-street="' + el.properties.name + '" d-latlng="' + arrLatLng + '" class="clickmap">' + `${el.properties.name}` + '</div>'

        this.rp = L.geoJSON(el, {
            style: function (feature) {
              return {color: feature.properties.color,
            };
          },
        }).addTo(this.layerGroup);

        this.rp.on('click', this.middleMan, this);

        this.rp.bindPopup(this.popup);

        this.rp.on('mouseover', function (this, e) {
          
          this.popup = L.popup().setLatLng(getLatLng).setContent(popEl);

          this.popup.openOn(this._map);
        });

    });

    this.mapPopupClick(this.languageId);

    this.loading = false;

    console.log('Done populating.');
  }

  mapPopupClick(languageId) {

    const scopeOject = this;
    $("body").on('click', 'div.clickmap', function (e) {
      console.log({'mapPopupClick this':this});
      let name = $(this).attr('d-street');
      let latlng = JSON.parse('[' + $(this).attr('d-latlng') + ']');
      let color = $(this).attr('d-color');
      scopeOject.getTrafficPredictionData(name, latlng, color, scopeOject.languageId);
      e.preventDefault();
    })
  }

  middleMan(e) {
    // console.log({'middleMan':e});
    
    let element = $(e.target.popup._content);
    let sName = $(element).attr('d-street');
    let currColor = e.layer.options.color;
    let sLatLng = [e.latlng.lat, e.latlng.lng];
    this.currentName = sName;
    this.currentLatLng = sLatLng;
    this.currColor = currColor;
    this.getTrafficPredictionData(sName, sLatLng, currColor, this.languageId);
  }

  getTrafficPredictionData(sn, ltlg?, currClr?, lng?) {

    let errMsg;

    let postObj = {
      "street": sn,
      "city": this.selCity
    };

    let current = { "status": null, "color": null};
    let onehour = { "status": null, "color": null};
    let twohours = { "status": null, "color": null};
    let threehours = { "status": null, "color": null};

    if (sn != "undefined") {
      this.showNoData = false;
      this.loading = true;
      this.sharedService.postDirect('service-trafficinfo/getTrafficInfoPrediction/', postObj, true).subscribe(
        data => {

          // this.portalservice.errorHandling(data, (function () {
            this.streetPrediction = data['data'];
          //   this.streetPrediction = {
          //         "status": {
          //             "current": {
          //                 "level": 1,
          //                 "color": "green"
          //             },
          //             "onehour": {
          //                 "level": 1,
          //                 "color": "green"
          //             },
          //             "twohours": {
          //                 "level": 1,
          //                 "color": "green"
          //             },
          //             "threehours": {
          //                 "level": 1,
          //                 "color": "green"
          //             }
          //         },
          //         "details": {
          //             "speed": [
          //                 80.0,
          //                 66.60045472021788,
          //                 59.29658863229454,
          //                 63.225492772828254
          //             ]
          //         }
          // };

            // console.log({'streetPrediction':this.streetPrediction});

            if (this.streetPrediction) {

              this.streetName = null;
              this.streetName = sn;
              this.gotPrediction = true;
              this.selStreetName = sn;
              this.predictionData = [];

              current.status = this.streetPrediction.status.current;
              current.color = currClr;

              onehour.status = this.streetPrediction.status.onehour;
              onehour.color = this.streetPrediction.status.onehour.color;

              twohours.status = this.streetPrediction.status.twohours;
              twohours.color = this.streetPrediction.status.twohours.color;

              threehours.status = this.streetPrediction.status.threehours;
              threehours.color = this.streetPrediction.status.threehours.color;

              this.predictionData.push(current);
              this.predictionData.push(onehour);
              this.predictionData.push(twohours);
              this.predictionData.push(threehours);

              // let speed:any = [];

              // this.streetPrediction.details.speed.forEach(el => {
              //   speed.push(el.toFixed());
              // });
              // this.predictionData.speed = speed;

              // console.log({'predictionData':this.predictionData});
              

              this.mymap.once('moveend', () => {
                let popEl = '<div '+this.mStyle+' d-color="' + current.color + '" d-street="' + this.streetName + '" d-latlng="' + ltlg + '" class="clickmap">' + this.streetName + '</div>'
                this.popup = L.popup().setLatLng(ltlg)
                  .setContent(popEl)
                  .openOn(this.mymap);
                this.popup.on('click', this.middleMan, this);
              });
              this.mymap.flyTo(ltlg, 15);
            }


          // }).bind(this));
          this.loading = false;
          this.isActiveList = false;
        }, err => {

          this.gotPrediction = false;
          this.showNoData = false;
          this.loading = false;
          this.predictionData = [];
          this.gotPrediction = true;

          this.streetName = null;
          this.streetName = sn;
          this.selStreetName = sn;

          let trafficDetails =
          {
            "status": null,
            "color": currClr
          };

          this.predictionData.push(trafficDetails)

          // console.log(this.predictionData.length)
          // this.sharedService.showError(JSON.parse(err._body).statusDesc, '');
          this.isActiveList = false;

        });
    } else {
      this.gotPrediction = false;
      this.showNoData = true;
      this.isActiveList = false;
    }

  }

  triggerDserviceValidation(dsvcCode) {
    let sub;
    this.loading = true;

    return this.route.paramMap
      .switchMap((params: ParamMap) =>
        this.portalservice.validateDserviceByRefCode(dsvcCode))
      .subscribe(resValidation => {

        if (!resValidation.valid) {
          this.sharedService.showError('Invalid Service!', '');
          this.router.navigate(['404']);

          this.loading = false;
        } else {
          localStorage.setItem('dserviceCode', dsvcCode);
          this.loading = false;
        }
      },
        error => {
          this.sharedService.showError(JSON.parse(error._body).statusDesc, '');
          this.loading = false;

        });
  }

}



// WEBPACK FOOTER //
// ./src/app/trafficinfo/trafficinfo.component.ts